/* ============================================================
   fix-zindex-dropdown.js
   ============================================================
   Posiciona el dropdown de Sign In (y otros dropdowns del header)
   usando position:fixed + getBoundingClientRect del boton trigger.
   Asi el dropdown:
   - Escapa TODOS los stacking contexts (fixed al viewport)
   - Queda anclado VISUALMENTE debajo del boton correcto
   - Se reposiciona en resize y scroll
   ============================================================ */
(function(){
  "use strict";

  function qs(sel, root){ return (root||document).querySelector(sel); }

  function positionDropdown(drop, trigger, opts){
    opts = opts || {};
    var offset = typeof opts.offset === "number" ? opts.offset : 8;
    if(!drop || !trigger) return;
    if(!drop.classList.contains(opts.openClass || "is-open")) return;
    var r = trigger.getBoundingClientRect();
    var vw = window.innerWidth || document.documentElement.clientWidth;
    // Queremos alinear el borde derecho del dropdown con el borde derecho del boton.
    var rightPx = Math.max(8, vw - r.right);
    var topPx = Math.max(0, r.bottom + offset);
    drop.style.setProperty("position", "fixed", "important");
    drop.style.setProperty("top", topPx + "px", "important");
    drop.style.setProperty("right", rightPx + "px", "important");
    drop.style.setProperty("left", "auto", "important");
    drop.style.setProperty("bottom", "auto", "important");
    drop.style.setProperty("z-index", "2147483647", "important");
  }

  function attachDropdown(wrapSel, dropSel, triggerSel, openClass){
    var wrap = qs(wrapSel);
    if(!wrap) return;
    var drop = qs(dropSel, wrap) || qs(dropSel);
    var trigger = qs(triggerSel, wrap) || qs(triggerSel);
    if(!drop || !trigger) return;
    openClass = openClass || "is-open";

    var reposition = function(){ positionDropdown(drop, trigger, {openClass: openClass}); };

    // Observar cambios de clase en el dropdown
    var obs = new MutationObserver(function(muts){
      for(var i=0;i<muts.length;i++){
        if(muts[i].type === "attributes" && muts[i].attributeName === "class"){
          if(drop.classList.contains(openClass)) reposition();
        }
      }
    });
    obs.observe(drop, { attributes: true, attributeFilter: ["class"] });

    window.addEventListener("resize", reposition, { passive: true });
    window.addEventListener("scroll", reposition, { passive: true });

    // Click inicial (por si el toggle ya sucedio antes de cargar este script)
    if(drop.classList.contains(openClass)) reposition();

    // Hook al click del trigger para reposicionar apenas abra
    trigger.addEventListener("click", function(){
      // Siguiente tick, cuando ya agregaron is-open
      setTimeout(reposition, 0);
      setTimeout(reposition, 50);
    });
  }

  function init(){
    // Account dropdown (Sign In)
    attachDropdown(".dh-account-wrap", ".dh-account-drop", ".dh-account-trigger, [data-account-toggle], button, a[href*='account']", "is-open");

    // Location dropdown (si existe)
    attachDropdown(".dh-loc", ".dh-loc__dropdown", ".dh-loc__trigger, [data-loc-toggle], button", "active");

    // Search results (si existe)
    // Nota: search results ya tiene ancho = search bar, no requiere reposition tipico.
  }

  if(document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
